/* =======================================
   GETTING STARTED
   ======================================= */

import ExportSettings from '../../config/_export-settings';
import Globals from './_globals';

export default class GettingStarted {
	
	constructor(
		private settings: ExportSettings,
		private globals: Globals
	) {
		
		this.globals.$wrapper.find('.panel a').address();
		this.bindEvents();
		
	}
	
	bindEvents() {
	
		this.globals.$contentWrapper.on('click', '.template-export', (evt: JQueryEventObject) => {
			this.globals.tooltip.destroyTooltips(this.globals.$contentWrapper);
			this.globals.runExport({
				template_id: $(evt.currentTarget).data('id')
			});
			this.globals.tooltip.addTooltips(this.globals.$contentWrapper);
		});
	
	}
	
}


// WEBPACK FOOTER //
// ./assets/js/src/components/export-central/_getting-started.ts